<template>
    <blur-modal
        :is-open="inspectModalShown"
        :always-open="false"
        :absolute-header="true"
        :aria-label="`Inspect ${inspectModalComponent.description[0].name}`"
        :is-inspect-modal="true"
        @closed="closeModal"
        @actuallyClosed="closeForReal"
    >
        <div class="inspect-modal__content">
            <p class="cz2__sr-only">
                {{ $t('SR_PREVIEW_ROTATE_INSTRUCTIONS') }}
            </p>

            <model-preview
                v-if="inspectModalShown"
                :component="inspectModalComponent"
            />

            <model-preview-controls v-if="!isKiosk" />

            <div class="cz2__modal-popup__actions">
                <btn
                    primary
                    @click="closeModal"
                >
                    {{ $t('ACTION_OKAY') }}
                </btn>
            </div>
        </div>
    </blur-modal>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .inspect-modal__content {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1 1 0%;

            padding-bottom: 50px;

            .cz2__btn--primary {
                margin-top: 50px;

                height: 48px;
                width: 250px;

                font-size: 20px;
            }
        }

        @include respond-above(sm) {
            .inspect-modal__content {
                padding-bottom: 90px;
            }

            .cz2__btn--blue {
                margin-top: 90px;
            }

            .cz2__btn--blue {
                width: 320px;

                font-size: 22px;
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__btn--blue {
            height: 64px;
            width: 319px;
        }

        .cz2__blur-modal-close {
            margin-top: 0;
        }

        // TODO: Use camera instead
        .model-preview {
            scale: 0.7;
            min-height: 500px !important;
        }
    }
</style>

<script>
    import Btn from './ui/Btn.vue';
    import BlurModal from './ui/BlurModal.vue';

    import ModelPreview from './ModelPreview.vue';
    import ModelPreviewControls from './ModelPreviewControls.vue';

    export default {
        components: {
            Btn,
            BlurModal,
            ModelPreview,
            ModelPreviewControls,
        },

        data() {
            return {
                tryClosing: false,
            };
        },

        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            inspectModalShown() {
                if (this.tryClosing) {
                    return false;
                }

                return this.$store.state.inspectModalShown;
            },

            inspectModalComponent() {
                return this.$store.state.inspectModalComponent;
            },
        },

        methods: {
            closeModal() {
                this.tryClosing = true;
            },

            closeForReal() {
                this.$store.dispatch('setInspectModalComponent', null);
                this.$store.dispatch('showInspectModal', false);
            },
        },
    };
</script>
